import { render, staticRenderFns } from "./About.vue?vue&type=template&id=f255a4aa&scoped=true&"
import script from "./About.vue?vue&type=script&lang=true&"
export * from "./About.vue?vue&type=script&lang=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f255a4aa",
  null
  
)

export default component.exports